import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useApiClientProject } from '~/@api/client/useApiClientProject'

export type GetProjectDetailsParams = {
  businessId: string
  stageNumber: string
}

function useProjectDetailQuery({
  businessId,
  stageNumber,
}: GetProjectDetailsParams) {
  const client = useApiClientProject()

  async function fetchProjectDetail() {
    return client.project
      .projectControllerGetProjectDetail(
        Number(businessId),
        Number(stageNumber),
        {
          secure: true,
        }
      )
      .then((resp) => resp.data.project)
  }

  return useQuery({
    queryKey: ['project-detail', businessId, stageNumber],
    queryFn: fetchProjectDetail,
    // throwOnError: true,
    retry: false,
    placeholderData: keepPreviousData,
  })
}

export { useProjectDetailQuery }
